import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface RatingFieldModel extends BaseFieldModel {
  defaultValue: number | undefined;
  count: number;
  allowHalf: boolean;
  starColor: string | undefined;
  type: FieldType.Rating;
}

export class RatingField extends BaseField implements RatingFieldModel {
  public defaultValue: number | undefined;
  public count = 5;
  public allowHalf = true;
  public starColor: string | undefined;
  public type: FieldType.Rating = FieldType.Rating;

  constructor(cultures: string[]) {
    super(FieldType.Rating, cultures);
  }
}
